import { Alert, Box } from '@mui/material';

export function NoAccessPage() {
  return (
    <Box sx={{ p: 4 }}>
      <Alert severity="info">Your account has no access yet. Ask an administrator to assign you a role.</Alert>
    </Box>
  );
}
